import _vsop87Bearth from 'astronomia/data/vsop87Bearth';
export var vsop87Bearth = _vsop87Bearth;